module.exports = require("./ff-Latn-LR.d.ts");